import { Button, Image, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './NewbuildingBrokerFlatBanner.css';
import rightImageUrl from './assets/right.png';
import { TNewbuildingBrokerFlatBannerButtonType } from './types';

interface INewbuildingBrokerFlatBannerProps {
  onButtonClick: (buttonType: TNewbuildingBrokerFlatBannerButtonType) => void;
}

export const NewbuildingBrokerFlatBanner: React.FC<INewbuildingBrokerFlatBannerProps> = ({ onButtonClick }) => {
  const handleSimilarButtonClick = React.useCallback(() => {
    onButtonClick('similar');
  }, [onButtonClick]);

  const handleNotSimilarButtonClick = React.useCallback(() => {
    onButtonClick('notSimilar');
  }, [onButtonClick]);

  return (
    <CardSectionNew hideForPrint data-testid="NewbuildingBrokerFlatBanner">
      <div className={styles['container']}>
        <div className={styles['left']}>
          <div className={styles['text']}>
            <UIHeading1>
              Похоже на{NBSP}то, что{NBSP}вы{NBSP}ищете?
            </UIHeading1>
          </div>
          <div className={styles['actions']}>
            <Button onClick={handleSimilarButtonClick}>Да, похоже</Button>
            <Button onClick={handleNotSimilarButtonClick}>Совсем не то</Button>
          </div>
        </div>
        <div className={styles['right']}>
          <Image preloader={false} src={rightImageUrl} loading="lazy" />
        </div>
      </div>
    </CardSectionNew>
  );
};
